import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {getNextScheduledReadable, SystemStickerType} from 'yougile-model'
import {EventBus} from '@client/event-bus'
import {openRepeatTemplatesEvent} from '@client/events'
import {RepeatClient} from '@client/repeat-client'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'
import {PageService} from '@extensions/page-service'
import {Button} from '../../../common/base/buttons'

export const StickerMenuRepeatPanel = observer(() => {
  const [, store] = useStickerStore()

  const bem = Util.bemFrom('repeat-view')
  const board = PageService.getCurrentBoard()
  const templates = RepeatClient.getBoardTemplates(board)
    .map(h => h.data.repeatTemplate)
    .filter(Util.isDefined)
    .reverse()
  const totalCount = templates.length

  const click = () => {
    EventBus.dispatch(
      openRepeatTemplatesEvent({
        boardId: board?.id
      })
    )
    store.closeStickerMenu()
  }

  return (
    <div className="max-w-[250px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          showSettings={false}
        />
      </div>
      <div className="sticker-item-list-body">
        <div className={bem('cnt')}>
          <div className={bem('count')}>
            {totalCount > 0 ? (
              <>
                {Lang.msg.repeat.someTasks1} <b>{totalCount}</b>{' '}
                {Lang.msg.repeat.someTasks2(totalCount)}:
              </>
            ) : (
              Lang.msg.repeat.noTasks
            )}
          </div>
          <div className={bem('tpl-list')}>
            {templates.map(tpl => {
              return (
                <div
                  key={tpl.id}
                  className={bem('tpl', {stopped: !tpl.schedule})}
                >
                  <div className={bem('tpl-icon')} />
                  <div className={bem('tpl-title')}>{tpl.title}</div>
                  <div className={bem('tpl-descr')}>
                    {!tpl.schedule
                      ? Lang.msg.repeat.stopped
                      : Lang.msg.repeat.willAppear +
                        ': ' +
                        getNextScheduledReadable(tpl.schedule)}
                  </div>
                </div>
              )
            })}
          </div>
          <Button size="small" onClick={click}>
            {totalCount > 0 ? Lang.msg.repeat.edit : Lang.msg.repeat.create} »
          </Button>
        </div>
      </div>
    </div>
  )
})
